import React from "react";
import { ClipboardCheckIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { Countdown } from "../Countdown";
import { MOCKUP_URL } from "../../data/landing";
export function Hero() {
  return <header className="w-full bg-cream px-5 pb-16 pt-8 md:pb-24 md:pt-12" data-id="element-156" data-mp="cv32tt32i8e9">
      <div className="mx-auto max-w-5xl text-center" data-id="element-157" data-mp="hvh2amqlsa0o">
        <div className="inline-flex items-center gap-2.5 rounded-full border border-line bg-white px-3 py-1.5 shadow-sm" data-id="element-158" data-mp="hsutykvw1qhe">
          <span className="flex h-7 w-7 items-center justify-center rounded-full bg-ink text-white" data-id="element-159" data-mp="qvm48hd12g7g">
            <ClipboardCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-160" data-mp="vmm4nwlcvgep" />
          </span>
          <span className="text-[13px] font-bold uppercase tracking-wide text-ink" data-id="element-161" data-mp="10lfi5p0n77ev">
            Breast Augmentation Clinical Pathway™
          </span>
        </div>

        <h1 className="mx-auto mt-7 max-w-4xl font-serif text-[36px] font-extrabold leading-[1.08] text-ink md:text-6xl" data-id="element-162" data-mp="15m34vyhu923a">
          Analyze an educational breast augmentation case in{" "}
          <em className="text-rose" data-id="element-163" data-mp="9om18jfz0gs4">approximately 15 minutes</em>
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-[17px] leading-relaxed text-inkSoft md:text-xl" data-id="element-164" data-mp="4ogbj8t9h4co">
          A structured case-review system designed to help you organize your observations, identify relevant
          variables, recognize information gaps, prioritize what deserves further review, and turn each educational
          case into a repeatable learning exercise.
        </p>

        <p className="mx-auto mt-5 inline-block rounded-xl bg-roseSoft px-4 py-2.5 text-[15px] font-semibold text-ink" data-id="element-165" data-mp="nepgurkchc8l">
          <strong data-id="element-166" data-mp="inft5wicwizc">6 Premium Volumes</strong> + <strong data-id="element-167" data-mp="imedtfub5abt">5 Professional Bonuses</strong> + <strong data-id="element-168" data-mp="enfa1ykbbjly">30+ Case-Review Tools</strong>
        </p>

        <img src={MOCKUP_URL} alt="All six volumes, case-review tools and bonuses of the Breast Augmentation Clinical Pathway" className="mx-auto mt-6 w-full max-w-3xl" data-id="element-169" data-mp="ekt3o295ra5b" />

        <div className="mt-6" data-id="element-170" data-mp="30lxesdauegya">
          <CtaButton id="first-cta" label="I want the Clinical Pathway™" caption="Instant digital access · One-time payment of $27 · Lifetime access · 7-day guarantee" data-id="element-171" data-mp="30lnm2hyexvow" />
          <Countdown data-id="element-172" data-mp="2qvcjayqgtsjl" />
        </div>
      </div>
    </header>;
}